<script>
import Endpoints from '../../../components/common/Endpoints';
import Common from '../../../components/common/Common';
import Request from '../../../components/common/Request';
import { mapActions } from 'vuex'

export default {
    init: (payload) => {
        const el = document.body;
        el.removeAttribute("class");
        $('.modal').modal('hide');

        payload.domain = Endpoints.domain;

        Request.do(payload, 'GET', Request.getDefaultHeader(payload), null, `${Endpoints.parts.groups.group}`,
        (response)=>{//SUCCESS CALLBACK
            payload.groups = response.results;
        },
        (error)=>{//ERROR CALLBACK
            console.log(error);
        });
        Request.do(payload, 'GET', Request.getDefaultHeader(payload), null, `${Endpoints.parts.families.family}`,
        (response)=>{//SUCCESS CALLBACK
            payload.families = response.results;
        },
        (error)=>{//ERROR CALLBACK
            console.log(error);
        });
        Request.do(payload, 'GET', Request.getDefaultHeader(payload), null, `${Endpoints.parts.brands.brand}`,
        (response)=>{//SUCCESS CALLBACK
            payload.brands = response.results;
        },
        (error)=>{//ERROR CALLBACK
            console.log(error);
        });
    },
    methods:{
        save: function(){
            $('#spinner').modal('toggle');
            this.errors = [];
            this.messageIdToast = null;
            let state = this;

            let data = JSON.parse(JSON.stringify(this.data));
            if (data.price){
                data.price = data.price.toString().split(".").join("").split(",").join(".").split("R$ ").join("");
            }

            Request.do(this, data._id ? 'PUT' : 'POST', Request.getDefaultHeader(this), data, `${Endpoints.parts.parts.part}${data._id ? data._id : ''}`,
                (response)=>{//SUCCESS CALLBACK
                    state.data._id = response.result._id;
                    state.valuekey += 1;
                    $('#spinner').modal('toggle');
                },
                (error)=>{//ERROR CALLBACK
                    $('#spinner').modal('toggle');
                    let res = error.response;
                    if (res && res.status){
                        this.titleToast = this.$t("string.msg.warning");
                        
                        if (res.data.messageId === 'response.msg.error.empty.fields'){
                            let fields = "";
                            res.data.errors.forEach(function (value) {
                                fields += state.$t(value.id)+";<br/>";
                            });
                            this.titleToast = this.$t(res.data.messageId);
                            this.messageToast = this.$t(fields);
                        }else{
                            this.messageToast = this.$t(res.data.messageId);
                            this.messageIdToast = res.data.messageId;
                        }

                        $('#toast').modal('show');
                    }
                    console.log(JSON.stringify(error));
            });
        },
        selectItem: function(item){
            this.data = JSON.parse(JSON.stringify(item));
            this.data = JSON.parse(JSON.stringify(item));
            this.data.name = Common.camelize(this.data.name);
            this.data.description = Common.camelize(this.data.description);
            this.data.partGroup = this.data.partGroup._id;
            this.data.partFamily = this.data.partFamily._id;
            this.data.partBrand = this.data.partBrand._id;
            this.data.oldPhotoURL = this.data.photoURL;
            this.data.price = parseFloat(Math.round(this.data.price * 100) / 100).toFixed(2);
            this.data.price = this.data.price.toString().split(",").join("").split(".").join(",");
        },
        clearForm: function(){
            this.data = {};
            this.data.status = "ACTIVE";
        },
        camelize: Common.camelize,
    }
}
</script>
